import { FILIAL_EMPRESA_GET, FilialActionTypes, FilialState } from "domain/types/filial/filial";
import { FilialResponse } from "domain/types/filial/filialResponse";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { PagedReducer } from "../../../utils/reducerUtil";

const INITIAL_STATE: FilialState = {
    Filiais: undefined,
}

export function FilialReducer(state = INITIAL_STATE, action: FilialActionTypes): FilialState {
    switch (action.type) {
        case FILIAL_EMPRESA_GET:
            return PagedReducer(state, "Filiais", action.payload, "FilialID", FILIAL_EMPRESA_GET)
            return {
                ...state,
                Filiais: {
                    ...state.Filiais,
                    Result:
                        [
                            ...(state.Filiais?.Result ?? []),
                            ...action.payload.Result.filter(
                                newUser => !(state.Filiais?.Result ?? []).some(
                                    existingUser => existingUser.FilialID === newUser.FilialID
                                )
                            )
                        ].sort((a, b) => a.NomeFantasia.localeCompare(b.NomeFantasia)),
                    TotalCount: action.payload.TotalCount,
                    Count: action.payload.Count,
                    //AsDataTables: action.payload.AsDataTables
                } as IPagedListResponse<FilialResponse>
            };

        default:
            return state
    }
}